<div class="flex" style="height: 100%">
  <div class="flex-row" style="height: 100%; width: 100%; padding: 0.5rem">
    @defer (when data()?.data) {
      <p-splitter
        class="main"
        [panelStyle]="{
          'white-space': 'nowrap',
          'text-overflow': 'ellipsis',
          overflow: 'hidden',
        }"
        [style]="{ height: '100%' }"
        (onResizeStart)="onResizeStart()"
        (onResizeEnd)="onResizeEnd()"
      >
        <ng-template pTemplate>
          <div class="pdf-overlay">
            <embed
              style="height: 100%; width: 100%"
              *ngIf="pdfSrc$ | async as pdfSrc; else message"
              [src]="pdfSrc"
            >
            <ng-template #message>
              <p class="centered" style="height: 100%">Es gibt keine Vorschau zum Anzeigen.</p>
            </ng-template>

            <div #overlayElement class="embed-overlay"></div>
          </div>
        </ng-template>

        <ng-template pTemplate>
          <div class="flex-column editor">
            <mat-button-toggle-group
              [value]="selectedInvoice()"
              (change)="onSelectedInvoiceChange($event)"
            >
              @if (isInvoice) {
                <mat-button-toggle
                  [value]="1"
                  [checked]="this.selectedInvoice() === 1"
                  matTooltip="Standardkonfiguration"
                  [matTooltipShowDelay]="1000"
                >
                  Standardkonfiguration
                </mat-button-toggle>
              }

              @for (invoiceTemplate of data()?.data; track invoiceTemplate.signature) {
                <mat-button-toggle
                  [value]="invoiceTemplate"
                  [checked]="getSelectedSignature() == invoiceTemplate.signature"
                  [matTooltip]="invoiceTemplate.name"
                  [matTooltipShowDelay]="1000"
                >
                  @if (isTemplateIncomplete(invoiceTemplate.signature)) {
                    <mat-icon
                      class="red-icon"
                      style="margin-right: auto"
                      [svgIcon]="EsvgFiles.warning"
                      matTooltip="Die Standardsprache ist für dieses Template nicht konfiguriert."
                    />
                  }

                  {{ invoiceTemplate.name }}
                </mat-button-toggle>
              }

              @if (!isInvoice) {
                <mat-button-toggle
                  [value]='"+"'
                  (click)="addDunningLevel()"
                  style="max-width: 3rem"
                  matTooltip="Neue Mahnstufe hinzufügen"
                  [matTooltipShowDelay]=1000
                >
                  +
                </mat-button-toggle>
              }
            </mat-button-toggle-group>

            <div
              class="flex-row mat-h3"
              style="
                gap: 5px;
                padding-top: 0.25rem;
                margin-bottom: 0;
              "
            >
              @if (isInvoice) {
                <mat-slide-toggle
                  labelPosition="before" class="mat-h3"
                  [(ngModel)]="isCancellationConfig"
                >
                  <span style="font-size: 20px;">Storno bearbeiten</span>
                </mat-slide-toggle>
              }

              @if (configuredLanguages().length > 0) {
                <div
                  (mousedown)="onLanguageSelectMouseDown($event)"
                  style="display: flex; align-items: center"
                >
                  <kpi4me-select-element
                    #languageSelectRef
                    [formControlElement]="languageFormControl"
                    [options]="configuredLanguages()"
                    label="Sprache"
                    [multiple]="false"
                    [deleteEnabled]="false"
                    [createNewEnabled]="false"
                    [editEnabled]="false"
                  />
                </div>
              }

              @if (unconfiguredLanguages().length > 0) {
                <button
                  mat-raised-button
                  color="accent"
                  (click)="createLanguageConfiguration()"
                  style="margin: 5px"
                >
                  Neue Sprache konfigurieren
                </button>
              }
            </div>

            @if (isInvoice) {
              <button
                mat-stroked-button
                (click)="openInvoiceAutomationTab()"
                style="margin-top: 0.25rem; margin-bottom: 0.5rem"
              >
                Rechnungsautomation
              </button>
            }

            @if (selectedInvoice() == 1) {
              <app-templates-form
                #standardFormRef
                [form]="standardForm()"
                [defaultForm]="standardForm()"
                [isDefault]="true"
                [isInvoice]="isInvoice"
                [dataFields]="dataFields()"
              />
            } @else {
              <app-templates-form
                #displayedFormRef
                [form]="displayedForm()"
                [defaultForm]="standardForm()"
                [isDefault]="false"
                [isInvoice]="isInvoice"
                [dataFields]="dataFields()"
              />
            }
            <button
              mat-raised-button
              color="accent"
              (click)="saveChanges()"
              style="margin: 5px"
              [disabled]="(selectedInvoice() == 1 ?
                standardFormRef()?.form?.invalid : displayedFormRef()?.form?.invalid) || false"
            >
              Speichern
            </button>


            @if (selectedInvoice() != 1) {
              <button
                mat-raised-button
                color="warn"
                (click)="deleteConfig()"
                style="margin: 5px"
              >
                Vorlage löschen
              </button>
            }
            @if (!isInvoice && data()?.data?.length > 1) {
              <button
                mat-raised-button
                color="warn"
                (click)="deleteDunningLevel()"
                style="margin: 5px"
              >
                letzte Mahnstufe löschen
              </button>
            }
          </div>
        </ng-template>
      </p-splitter>
    }
  </div>
</div>
